<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 16px;padding: 10px;box-shadow: 0 8px 24px rgba(0, 37, 62, 0.12);">
              <span class="login-title">
                <img :src="igreja.logoUrl" width="230px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Dados do pai:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field light label="CPF DO PAI*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'" data-vv-name="cpf" type="tel" v-model="responsavel.pai.cpf" @change="consultaCPF(responsavel.pai.cpf, 'pai')" append-outer-icon="search"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light disabled v-model="responsavel.pai.nome" label="NOME DO PAI" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field disabled light v-model="responsavel.pai.telefone" label="TELEFONE DO PAI" outlined color="#00695C" required dense hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Dados da mãe:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field light label="CPF DA MÃE" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'" data-vv-name="cpf" type="tel" v-model="responsavel.mae.cpf" @change="consultaCPF(responsavel.mae.cpf, 'mae')" append-outer-icon="search"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light disabled v-model="responsavel.mae.nome" label="NOME DA MÃE" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field disabled light v-model="responsavel.mae.telefone" label="TELEFONE DA MÃE" outlined color="#00695C" required dense hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Dados da criança:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-text-field light v-model="membro.nome" label="NOME COMPLETO DA CRIANÇA*" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-select outlined dense v-model="membro.sexo" :items="sexo" hide-details item-text="titulo" item-value="id" color="#00695C" label="SEXO*"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field type="tel" light v-model="membro.dataNascimento" label="DATA DE NASCIMENTO*" single-line outlined color="#00695C" required v-mask="'##/##/####'" dense hide-details :error-messages="errors.collect('dateOfBirth')" return-masked-value mask="##/##/####" data-vv-name="dateOfBirth"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-select outlined dense v-model="redeSelecionada" :items="redes" hide-details item-text="nome" item-value="id" color="#00695C" label="REDE" @input="carregaCelulas"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-select outlined dense :disabled="redeSelecionada == ''" v-model="membro.celulaId" :items="celulas" hide-details item-text="nome" item-value="id" color="#00695C" label="CÉLULA"></v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg6>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 24px;" large @click="criaMembro">Confirmar Cadastro</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoTemplusIntelite.png" width="300px">
          </a>
        </div>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card>
            <v-card-title>Informação</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <p class="texto" style="color:#00695C">Deseja matricular {{ membro.nome }} agora em Escola Bíblica Liberty?</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="criarInscricaoEvento">Sim</v-btn>
              <v-btn text color="primary" @click="closeDialog">Não</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogoCadastroEvento" persistent max-width="500px">
          <v-card>
            <v-card-title>Informação</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="success" size="100">check_circle</v-icon>
                    <p class="texto" style="color:#00695C">Cadastro efetuado com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialog">Concluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoNaoCadastrado" persistent max-width="500px">
          <v-card>
            <v-card-title>Atenção</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="warning" size="100">warning</v-icon>
                    <p class="texto" style="color: #666">O CPF informado não possui cadastro na **{{ igreja.nome }}**. <a href="https://templus.intelite.com.br/liberdade">Clique aqui</a> e cadastre-se agora.<br><br>Após realizar o seu cadastro, tente novamente.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dialogoNaoCadastrado = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// import CpfValidate from '../../componentes/validators/rules/cpf'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'
export default {
  components: { Snackbar, Loading, },
  name: 'Auth',
  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
  }),
  data: function () {
    return {
      idIgreja: '6390de5538a3bc18300a2022',
      igreja: {},
      user: {},
      eventoSelecionado: '',
      membro: {
        nome: '',
        dataNascimento: '',
        sexo: '',
        celulaId: '',
        igrejaId: '',
        tipo: ''
      },
      responsavel: {
        mae: {
          nome: '',
          cpf: '',
          telefone: '',
          id: '',
        },
        pai: {
          nome: '',
          cpf: '',
          telefone: '',
          id: '',
        },
      },
      informacoesBatismo: {
        batizado: null,
        igrejaBatismo: '',
        batismoLiberdade: null,
      },
      dialog: false,
      dialogoNaoCadastrado: false,
      dialogoCadastroEvento: false,
      redeSelecionada: '',
      sexo: ['MASCULINO', 'FEMININO'],
      estadoCivil: ['SOLTEIRO(A)', 'CASADO(A)', 'VIÚVO(A)', 'DIVORCIADO(A)', 'RELAÇÃO ESTÁVEL'],
      tipoMembro: ['CONGREGADO', 'MEMBRO'],
      tipoIntegracao: ['ATRAVÉS DE BATISMO', 'VENHO DE OUTRA IGREJA'],
      condicoes: [
        { value: true, text: 'SIM'},
        { value: false, text: 'NÂO'},
      ],
      redes: [],
      celulas: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      codigoExistente: '',
      msgResultado: '',
      codigoGerado: '',
      tipoFormulario: '',
      membroCarregado: [],
      membroId: '',
      dictionary: {
        custom: {
          dateOfBirth: {
            required: () => 'Informe a data de nascimento',
            date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
          },
        }
      },
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Insira um e-mail válido (apenas minúsculas)'
        },
      },
    }
  },

  mounted: function () {
    // Chamamos carregaDados que agora vai chamar carregaRedes() após obter o ID da igreja
    this.carregaDados()
  },

  watch: {
    'membro.batismoLiberdade'(val) {
      if (this.membro.batizado && val == true) {
        this.membro.tipo = 'MEMBRO'
      } else {
        this.membro.tipo = 'CONGREGADO'
      }
    },

    'membro.batizado'(val) {
      if (val == false) {
        this.membro.tipo = 'CONGREGADO'
      }
    }
  },

  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.idIgreja } })
        if (response.data) {
          this.igreja = response.data
          // Chamamos carregaRedes APÓS o id da igreja ser carregado
          await this.carregaRedes()
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar dados da igreja.', 'ERRO')
      } finally {
        this.isLoading = false
      }
    },

    async carregaRedes() {
      // Garantimos que igreja.id está disponível antes de fazer a chamada
      if (!this.igreja.id) {
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar redes.', 'ERRO');
        return;
      }
      await axios.post(baseApiUrl + 'Redes/listarPublicasPorTipo', {
        igrejaId: this.igreja.id,
        tipo: 'KIDS',
      })
      .then(response => {
        if (response.data) {
          this.redes = response.data
        }
      })
      .catch(() => { 
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar redes.', 'ERRO');
      });
    },

    async carregaCelulas() {
      // Certifique-se de que redeSelecionada não está vazia antes de carregar as células
      if (!this.redeSelecionada) {
        this.celulas = []; // Limpa as células se nenhuma rede estiver selecionada
        return;
      }
      await axios.post(baseApiUrl + 'Celulas/listarPorRedePublico', null, { params: { redeId: this.redeSelecionada } })
      .then(response => {
        if (response.data) {
          this.celulas = response.data
        }
      })
      .catch(() => { 
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar células.', 'ERRO');
      });
    },

    async consultaCPF(cpf, tipo) {
      var vm = this
      this.isLoading = true
      await axios.post(baseApiUrl + 'Membros/buscaPublicaCpf', null, { params: { cpf: cpf } })
      .then(response => {
        if (response.data && response.data.id) {
          const membroEncontrado = response.data
          if (tipo == 'pai') {
            if (membroEncontrado.sexo == 'MASCULINO') {
              this.responsavel[tipo].nome = membroEncontrado.nome
              this.responsavel[tipo].telefone = membroEncontrado.telefone
              this.responsavel[tipo].id = membroEncontrado.id
            } else {
              this.responsavel[tipo].cpf = ''
              vm.$refs.chamaSnackbar.snack("#F9A825", "CPF informado precisa ser do pai", "ATENÇÃO")
            }
          } else if (tipo == 'mae') {
            if (membroEncontrado.sexo == 'FEMININO') {
              this.responsavel[tipo].nome = membroEncontrado.nome
              this.responsavel[tipo].telefone = membroEncontrado.telefone
              this.responsavel[tipo].id = membroEncontrado.id
            } else {
              this.responsavel[tipo].cpf = ''
              vm.$refs.chamaSnackbar.snack("#F9A825", "CPF informado precisa ser da mãe", "ATENÇÃO")
            }
          }
          this.isLoading = false
        } else {
          this.isLoading = false
          this.dialogoNaoCadastrado = true
        }
      })
      .catch(() => {
        this.isLoading = false;
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao consultar CPF.', 'ERRO');
      });
    },

    async criaMembro() {
      let responsavel
      if (this.responsavel.pai.cpf || this.responsavel.mae.cpf) {
        responsavel = 'PREENCHIDO'
      } else {
        responsavel = 'NÃO PREENCHIDO'
      }
      var vm = this;
      if (responsavel == 'NÃO PREENCHIDO' || !this.membro.nome || !this.membro.sexo || !this.membro.dataNascimento || !this.redeSelecionada || !this.membro.celulaId) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente!", "ATENÇÃO")
      } else {
        this.membro.tipo = 'CONGREGADO'
        this.membro.maeId = this.responsavel.mae.id
        this.membro.paiId = this.responsavel.pai.id
        this.isLoading = true
        this.membro.igrejaId = this.igreja.id
        await axios.post(baseApiUrl + 'Membros/salvarCriancaPublico', this.membro)
        .then(response => {
          if (response.data) {
            this.dialogoCadastroEvento = true
            this.isLoading = false
          }
        }).catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar cadastro. Verifique os dados informados e tente novamente", "DESCULPE")
        })
      }
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    closeDialog() {
      this.dialog = false
      this.vigilante = Object.assign({}, this.vigilanteDefault)
      this.$validator.reset()
      window.location.reload()
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.fim;
      const dataB = b.fim;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date
    },

    async criarInscricaoEvento() {
      this.dialog = false
      this.isLoading = true
      let dados = {
        "nome": this.membro.nome,
        "sexo": this.membro.sexo,
        "eventoId": "63c6e81ce59b554a3da1d616",
        "membroId": this.membroId,
        "igrejaId": this.idIgreja,
        "whatsApp": this.responsavel.mae.telefone != '' ? this.responsavel.mae.telefone : this.responsavel.pai.telefone,
      }
      await axios.post(baseApiUrl + 'inscricoes/salvarPublica', {
        ...dados,
        cpf: this.membro.cpf
      })
      .then(response => {
        if (response.data) {
          this.isLoading = false
          this.dialogoCadastroEvento = true
        }
      })
    },
  }
}
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center
}

@import '../../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css'
</style>
